import { makeStyles } from '@mui/styles';
import CircularProgress from 'apollo-react/components/CircularProgress';
import React from 'react';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  circularProgress: {
    '& > div': {
      display: 'flex',
    },
  },
});

const CustomLoader = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper} ui-ta="progressbar">
      <CircularProgress className={classes.circularProgress} variant="indeterminate" size={40} />
    </div>
  );
};

export default CustomLoader;
